import styles from "./ContactUs.module.css";
import {
  ContactUsButtons,
  ContactUsButtonType,
  ContactUsType,
} from "../../interfaces/contactUs/ContactUs.type";
import {
  getGeneralImage,
  isDeviceMobile,
  generateStyleClasses,
  styleHelper,
} from "../../helpers/commonFunctions";
import useComponentsStore from "../../store/componentsStateStore";
import FinalizeButton from "../finalizeButton/FinalizeButton";

export default function ContactUs({ data }: { data: ContactUsType }) {
  let { title, subtitle, borderColor, backgroundColor, buttonList } = data;
  const buttonItems = buttonList?.map(
    (button: ContactUsButtons) => button?.items
  );
  const { finalizeButton } = useComponentsStore();

  const handleRedirect = (link: string, tabOption: string) => {
    if (!link) return;
    window.open(link, tabOption);
  };

  function callPhoneNumber(button: ContactUsButtonType) {
    switch (button?.actionType) {
      case "whatsapp":
        handleRedirect("https://wa.me/" + button?.value, "_blank");
        break;
      case "phone":
        handleRedirect("tel:" + button?.value, "_self");
        break;
      case "deeplink":
        handleRedirect(button?.deeplink, "_blank");

        break;
      default:
        if (button?.deeplink) handleRedirect(button?.deeplink, "_blank");
        else break;
    }
  }

  return (
    <div
      className={`${styles.sticky_contact} ${
        isDeviceMobile() ? "vas-w-100 vas-px-2" : "vas-w-50"
      } vas-d-flex vas-flex-column vas-gap-2`}
    >
      <div
        className={`vas-p-3 vas-pt-4 vas-d-flex vas-flex-column vas-gap-3 vas-w-100 vas-shadow vas-border vas-border-radius`}
        style={styleHelper({ maxWidth: "", backgroundColor, borderColor })}
      >
        <span
          className={`vas-text vas-text-20 ${generateStyleClasses(
            title?.style
          )}`}
          style={styleHelper({ color: title?.textColor })}
        >
          {data.title?.text ?? ""}
        </span>
        <span
          className={`vas-text vas-text-14 vas-mb-1 ${generateStyleClasses(
            subtitle?.style
          )}`}
          style={styleHelper({ color: subtitle?.textColor })}
        >
          {data.subtitle?.text ?? ""}
        </span>
        {buttonItems &&
          buttonItems.length > 0 &&
          buttonItems.map((button, idx) => (
            <button
              className={`vas-btn vas-btn-lg vas-w-100 vas-mb-1 vas-border-radius vas-text-18 vas-d-flex vas-justify-content-center vas-align-items-center`}
              style={styleHelper({
                backgroundColor: button[0]?.backgroundColor,
                border: `1px solid ${button[0]?.borderColor}`,
              })}
              key={idx}
              onClick={() => callPhoneNumber(button[0])} // fix this after the demo
            >
              <img
                className="vas vas-mx-1"
                src={getGeneralImage(button[0]?.icon)}
                alt=" "
                width={25}
                height={25}
              />
              <span
                className={`${generateStyleClasses(button[0]?.style)}`}
                style={styleHelper({ color: button[0]?.textColor })}
              >
                {button[0]?.text}
              </span>
            </button>
          ))}
      </div>
      {finalizeButton && <FinalizeButton items={finalizeButton} />}
    </div>
  );
}
